import { useCallback, useEffect, useState } from 'react';
import { getPreviouslyUsedPolls } from '../../../../db/polls';
import { PollTypes, PreviouslyUsedPollItem } from '../../../../db/polls/types';
import { useAppContext } from '../../../../app/Context';
import Logger from '../../../../utils/logger';

export interface PreviouslyUsedPoll extends PreviouslyUsedPollItem {
  pollType: PollTypes.PREVIOUSLY_USED;
}

const usePreviouslyUsedPolls = () => {
  const { setError } = useAppContext();

  const [isFetchingPreviouslyUsedPolls, setIsFetchingPreviouslyUsedPolls] = useState(false);
  const [previouslyUsedPolls, setPreviouslyUsedPolls] = useState<PreviouslyUsedPoll[]>([]);

  const fetchPreviouslyUsedPolls = useCallback(async () => {
    setIsFetchingPreviouslyUsedPolls(true);
    try {
      const { previouslyUsedPolls } = await getPreviouslyUsedPolls();
      const transformedPreviouslyUsedPolls: PreviouslyUsedPoll[] = previouslyUsedPolls.map((activity) => {
        return {
          ...activity,
          pollType: PollTypes.PREVIOUSLY_USED,
        };
      });

      setPreviouslyUsedPolls(transformedPreviouslyUsedPolls);
    } catch (error: any) {
      setError(error.message);
      Logger.error(error);
    } finally {
      setIsFetchingPreviouslyUsedPolls(false);
    }
  }, []);

  useEffect(() => {
    fetchPreviouslyUsedPolls();
  }, [fetchPreviouslyUsedPolls]);

  return { isFetchingPreviouslyUsedPolls, previouslyUsedPolls };
};

export default usePreviouslyUsedPolls;
